export default {
  'booking.loadFailed': 'Không thể tải tour',
  'booking.notFound': 'Không tìm thấy tour',
  'booking.removed': 'Tour bạn đang cố đặt không tồn tại hoặc đã bị gỡ bỏ.',
  'booking.backToTours': 'Về danh sách tour',
  'booking.received': 'Đã nhận yêu cầu đặt tour!',
  'booking.thanks': 'Cảm ơn yêu cầu của bạn cho {{title}}. Yêu cầu đang chờ xác nhận và chuyên viên phụ trách sẽ liên hệ để hoàn tất xác nhận chi tiết.',
  'booking.checkStatus': 'Bạn có thể kiểm tra trạng thái và chi tiết đặt tour bất cứ lúc nào trong mục Đặt tour của tôi. Vui lòng đăng nhập bằng Email đã đặt tour.',
  'booking.logInView': 'Đăng nhập để xem đặt tour',
  'booking.viewBookings': 'Xem đặt tour của tôi',
  'booking.exploreMore': 'Khám phá thêm tour',
  'booking.home': 'Trang chủ',
  'booking.tours': 'Tours',
  'booking.bookJourney': 'Đặt hành trình của bạn',
  'booking.tellUs': 'Hãy cho chúng tôi biết đôi chút về chuyến đi của bạn và chuyên gia địa phương sẽ lo phần còn lại.',
  'booking.noAccount': 'Không cần tài khoản',
  'booking.guestNote': 'Bạn có thể đặt tour dưới dạng khách. Nếu email chưa được đăng ký, chúng tôi sẽ tự động tạo tài khoản để bạn theo dõi đặt tour.',
  'booking.signIn': 'Đăng nhập',
  'booking.ifAlreadyHave': 'nếu bạn đã có tài khoản.',
  'booking.spots': '{{count}} điểm',
  'booking.usdPerPerson': 'USD / người',
  'booking.subtotal': 'Tạm tính',
  'booking.total': 'Tổng cộng',
  'booking.guidePrice': 'Đây là giá tham khảo. Báo giá cuối cùng phụ thuộc vào ngày đi, quy mô đoàn và mùa, được xác nhận với chuyên gia địa phương trước khi đặt bất kỳ điều gì.',
  'booking.noPayment': 'Trang này không thu bất kỳ khoản thanh toán nào. Giấy phép số 01-2641/2024/CDLQGVN-GP LHQT',
  'booking.contactDetails': 'Thông tin liên hệ',
  'booking.fullName': 'Họ và tên',
  'booking.email': 'Email',
  'booking.phone': 'Số điện thoại',
  'booking.fullAddress': 'Địa chỉ đầy đủ',
  'booking.namePlaceholder': 'VD: Nguyễn Văn An',
  'booking.emailPlaceholder': 'ban@example.com',
  'booking.phonePlaceholder': '+84 ...',
  'booking.addressPlaceholder': 'Đường, thành phố, quốc gia...',
  'booking.tripDetails': 'Chi tiết chuyến đi',
  'booking.travelDate': 'Ngày đi mong muốn',
  'booking.datesFlexible': 'Ngày đi có thể linh hoạt — chuyên gia địa phương sẽ xác nhận tình trạng còn chỗ chính xác với bạn.',
  'booking.adults': 'Người lớn',
  'booking.children': 'Trẻ em',
  'booking.pickupPoint': 'Điểm đón',
  'booking.dropoffPoint': 'Điểm trả khách',
  'booking.pickupPlaceholder': 'VD: Phố cổ Hà Nội',
  'booking.dropoffPlaceholder': 'VD: Ninh Bình',
  'booking.specialRequests': 'Yêu cầu đặc biệt',
  'booking.specialPlaceholder': 'Nhu cầu ăn uống, hỗ trợ đi lại, nhịp độ mong muốn, tiện ích tuần trăng mật... bất cứ điều gì giúp chúng tôi lên kế hoạch.',
  'booking.charCount': '{{n}}/500 ký tự',
  'booking.payment': 'Thanh toán',
  'booking.paymentMethod': 'Phương thức thanh toán',
  'booking.bankTransfer': 'Chuyển khoản ngân hàng',
  'booking.creditCard': 'Thẻ tín dụng',
  'booking.momo': 'MoMo',
  'booking.zalopay': 'ZaloPay',
  'booking.cod': 'Thanh toán khi nhận',
  'booking.discountCode': 'Mã giảm giá',
  'booking.discountPlaceholder': 'VD: SUMMER10',
  'booking.apply': 'Áp dụng',
  'booking.applied': 'Đã áp dụng {{code}}',
  'booking.percentOff': 'Giảm {{value}}%',
  'booking.fixedOff': 'Giảm ${{value}}',
  'booking.estimatedTotal': 'Tổng ước tính',
  'booking.adultsUnit': 'người lớn',
  'booking.childrenUnit': 'trẻ em',
  'booking.halfPrice': 'nửa giá',
  'booking.confirmBooking': 'Xác nhận đặt tour',
  'booking.submitting': 'Đang gửi...',
  'booking.nothingCharged': 'Hiện chưa thu bất kỳ khoản nào. Chuyên gia địa phương sẽ xác nhận chi tiết trước khi thống nhất.',
  'booking.fillRequired': 'Vui lòng điền đầy đủ các trường bắt buộc.',
  'booking.submitFailed': 'Không thể gửi đặt tour. Vui lòng thử lại.',
  'booking.discountInvalid': 'Mã giảm giá không hợp lệ.',
  'booking.discountInactive': 'Mã giảm giá này đã ngừng hoạt động.',
  'booking.discountExpired': 'Mã giảm giá này đã hết hạn.',
  'booking.discountLimit': 'Mã giảm giá này đã đạt giới hạn sử dụng.',
  'booking.discountMismatch': 'Mã giảm giá không áp dụng cho tour này.',
  'booking.discountFailed': 'Không thể áp dụng mã giảm giá.',
  'booking.discountNotValid': 'Mã giảm giá không hợp lệ.',
  'booking.accountCreated': 'Tài khoản của bạn đã được tạo',
  'booking.accountCreatedNote': 'Chúng tôi thấy email của bạn chưa được đăng ký, nên đã tạo một tài khoản để bạn theo dõi đặt tour này.',
  'booking.password': 'Mật khẩu',
  'booking.hidePassword': 'Ẩn mật khẩu',
  'booking.showPassword': 'Hiện mật khẩu',
  'booking.copied': 'Đã sao chép',
  'booking.copy': 'Sao chép',
  'booking.changePassword': 'Đổi mật khẩu',
  'booking.changePasswordNote': 'Đặt một mật khẩu bạn dễ nhớ để không phải giữ mật khẩu ngẫu nhiên ở trên.',
  'booking.passwordUpdated': 'Đã cập nhật mật khẩu thành công. Bạn đã đăng nhập.',
  'booking.newPasswordPlaceholder': 'Mật khẩu mới (tối thiểu 6 ký tự)',
  'booking.confirmPasswordPlaceholder': 'Xác nhận mật khẩu mới',
  'booking.updatePassword': 'Cập nhật mật khẩu',
  'booking.updating': 'Đang cập nhật...',
  'booking.passwordMin': 'Mật khẩu phải có ít nhất 6 ký tự.',
  'booking.passwordMismatch': 'Mật khẩu không khớp.',
  'booking.passwordUpdateFailed': 'Không thể cập nhật mật khẩu. Vui lòng thử lại.',
  'booking.captchaRequired': 'Vui lòng xác nhận bạn không phải robot.',
  'booking.captchaFailed': 'Xác minh bảo mật thất bại. Vui lòng thử lại.',
};